module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB8SURBVHgBrdFBDYAwDIXhtwUBkwAOmBMs4ICd0MCJOcDCJOAAHDAJE8Ay2oQDV5b+yZKevnSpAnVNc6twbzT29Az+Fwoa1/klqhc7KqFviVCrCVsFMM7wLzUNA+TqGUyQyzB4Qq6gC/IImS3pKNnpzvtIg2UddfEyOxtsPeg7JeOEaCDSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/set5.png
// module id = WGnf
// module chunks = 1